document.addEventListener('DOMContentLoaded', () => {
  const productInfoSection = document.querySelector('.product-information[data-enable-sticky-atc]');
  if (productInfoSection && productInfoSection.getAttribute('data-enable-sticky-atc') === 'false') {
    return;
  }

  const atcButton = document.querySelector('.add-to-cart-button');
  if (!atcButton || !(atcButton instanceof HTMLElement)) return;

  const buttonOffsetTop = atcButton.offsetTop;
  let ticking = false;

  function updateStickyState() {
    ticking = false;
    if (!atcButton) return;
    if (window.scrollY + atcButton.offsetHeight > buttonOffsetTop) {
      atcButton.classList.add('sticky--show');
    } else {
      atcButton.classList.remove('sticky--show');
    }
  }

  document.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateStickyState);
    },
    { passive: true }
  );
});